import { __decorate } from "tslib";
import { AsnProp } from "@peculiar/asn1-schema";
import { LogotypeDetails } from "./logotype_details";
import { LogotypeImageInfo } from "./logotype_image_info";
export class LogotypeImage {
    constructor(params = {}) {
        this.imageDetails = new LogotypeDetails();
        Object.assign(this, params);
    }
}
__decorate([
    AsnProp({ type: LogotypeDetails })
], LogotypeImage.prototype, "imageDetails", void 0);
__decorate([
    AsnProp({ type: LogotypeImageInfo, optional: true })
], LogotypeImage.prototype, "imageInfo", void 0);
